import React from 'react';
import CommunityTermsPage from '@/components/cms/CommunityTermsPage';

const TermsOfService = () => {
  return <CommunityTermsPage />;
};

export default TermsOfService;